<ng-container
  *ngFor="let group of gameListService.eventGroups; let roundIndex = index"
>
  <div
    *ngIf="sortByRound || sortByLeague || groupByDate"
    class="group-header {{ colorScheme?.main }}"
  >
    <ng-container *ngIf="(sortByRound && showLeagueInfo) || sortByLeague">
      <img
        [src]="
          group.events[0]?.league_pictures
            | imageUrlBySubtype: logoType : logoSize
        "
        [alt]="group.events[0]?.league_info?.league_name"
        [lazyLoad]="lazyLoadImages"
        class="league-logo"
      />
      <a
        [href]="getLeagueLink(group.events[0]?.league_info?.league_readable_id)"
      >
        <div class="league-name">
          {{ group.events[0]?.league_info?.league_name }}
        </div>
      </a>
    </ng-container>
    <div
      *ngIf="(sortByRound || groupByDate) && group.name?.length > 0"
      class="group-name"
    >
      {{ group.name }}
    </div>
    <a
      *ngIf="sortByLeague && group.events[0]?.league_info?.league_readable_id"
      [href]="
        getLeagueLink(group.events[0]?.league_info?.league_readable_id) +
        '/tabelle'
      "
      class="table-link d-md-none"
    >
      Tabelle >
    </a>
  </div>
  <div
    scrollOnDrag
    class="games-list"
    [class.logos-outside]="logosOnOutside"
    [class.hide-shadow]="hideShadow"
    [class.can-scroll]="canScroll"
    [class.spaced]="spaced"
    [class.condensed]="condensed"
    [class.large]="large"
  >
    <ng-container *ngFor="let event of group.events; let gameIndex = index">
      <lib-game-list-item
        (click)="gameListItemClick.emit(event)"
        [event]="event"
        [user]="user"
        [live]="live"
        [spaced]="spaced"
        [inline]="inline"
        [condensed]="condensed"
        [large]="large"
        [lazyLoadImages]="lazyLoadImages"
        [showLeagueInfo]="showLeagueInfo && !sortByRound"
        [teamNameCentered]="teamNameCentered"
        [openLinksInNewTab]="openLinksInNewTab"
        [useRelativeLinks]="useRelativeLinks"
        [highlightOnHover]="highlightOnHover"
        [showDate]="showDate"
        [showRound]="showRound"
        [showStatus]="showStatus"
        [showImages]="showImages"
        [showReporterStatus]="showReporterStatus"
        [useAbbreviations]="useAbbreviations"
        [useLink]="useLink"
        [displayStatusBackground]="displayStatusBackground"
        [infoBackground]="infoBackground"
        [highlightGame]="highlightGames.includes(event._id)"
        [colorScheme]="colorScheme"
        [matchLinkPath]="matchLinkPath"
        [showDownloads]="showDownloads"
      ></lib-game-list-item>
      <lib-ad
        *ngIf="showAd(roundIndex, gameIndex) && showAds"
        class="my-1"
      ></lib-ad>
    </ng-container>
  </div>
</ng-container>
<div *ngIf="events?.length === 0 && !loading" class="games-list__empty">
  Keine Spiele vorhanden
</div>
